import { reactive } from 'vue'
import actions from '@/store/instructor/actions'
import state from '@/store/instructor/state'
import getters from '@/store/instructor/getters'

export const instructorModule = {
    state: reactive(state),
    actions,
    getters,
}
